import { render, staticRenderFns } from "./StocktakingRecordView.vue?vue&type=template&id=32166574&scoped=true&"
import script from "./StocktakingRecordView.vue?vue&type=script&lang=js&"
export * from "./StocktakingRecordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32166574",
  null
  
)

export default component.exports